import { createApp, h } from 'vue';
import EventExploreApp from '../components/event_explore/event_explore_app.vue';

document.addEventListener('DOMContentLoaded', () => {
  const element = document.getElementById('event_explore_app');

  if (element) {
    const dataset = element.dataset;

    // Parse initialMapView safely
    let initialMapView = null;
    if (dataset.initialMapView && dataset.initialMapView !== 'null') {
      try {
        initialMapView = JSON.parse(dataset.initialMapView);
      } catch (e) {
        console.warn('Failed to parse initialMapView:', e);
        initialMapView = null;
      }
    }

    const app = createApp({
      render: () => h(EventExploreApp, {
        initialFilters: JSON.parse(dataset.initialFilters),
        initialMapView: initialMapView,
        formData: JSON.parse(dataset.formData),
        useMetric: dataset.useMetric === 'true',
        copy: JSON.parse(dataset.copy),
        apiEndpoint: dataset.apiEndpoint,
        mapboxToken: dataset.mapboxToken
      })
    });
    app.mount(element);
  }
});
